// extracted by mini-css-extract-plugin
export default {"form_item":"app__css__app-pages-SelfHelp-channelJxkjsfdx-__index__form_item"};